/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ControlTransformation } from './ControlTransformation';
import {
    ControlTransformationFromJSON,
    ControlTransformationFromJSONTyped,
    ControlTransformationToJSON,
    ControlTransformationToJSONTyped,
} from './ControlTransformation';
import type { CatalogDto } from './CatalogDto';
import {
    CatalogDtoFromJSON,
    CatalogDtoFromJSONTyped,
    CatalogDtoToJSON,
    CatalogDtoToJSONTyped,
} from './CatalogDto';
import type { ResolutionMetadata } from './ResolutionMetadata';
import {
    ResolutionMetadataFromJSON,
    ResolutionMetadataFromJSONTyped,
    ResolutionMetadataToJSON,
    ResolutionMetadataToJSONTyped,
} from './ResolutionMetadata';
import type { ProfileDto } from './ProfileDto';
import {
    ProfileDtoFromJSON,
    ProfileDtoFromJSONTyped,
    ProfileDtoToJSON,
    ProfileDtoToJSONTyped,
} from './ProfileDto';

/**
 * 
 * @export
 * @interface ResolutionData
 */
export interface ResolutionData {
    /**
     * 
     * @type {CatalogDto}
     * @memberof ResolutionData
     */
    resolvedCatalog?: CatalogDto;
    /**
     * 
     * @type {ProfileDto}
     * @memberof ResolutionData
     */
    sourceProfile?: ProfileDto;
    /**
     * 
     * @type {ResolutionMetadata}
     * @memberof ResolutionData
     */
    resolutionMetadata?: ResolutionMetadata;
    /**
     * 
     * @type {Array<ControlTransformation>}
     * @memberof ResolutionData
     */
    controlTransformations?: Array<ControlTransformation>;
    /**
     * 
     * @type {string}
     * @memberof ResolutionData
     */
    sspId?: string;
}

/**
 * Check if a given object implements the ResolutionData interface.
 */
export function instanceOfResolutionData(value: object): value is ResolutionData {
    return true;
}

export function ResolutionDataFromJSON(json: any): ResolutionData {
    return ResolutionDataFromJSONTyped(json, false);
}

export function ResolutionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolutionData {
    if (json == null) {
        return json;
    }
    return {
        
        'resolvedCatalog': json['resolvedCatalog'] == null ? undefined : CatalogDtoFromJSON(json['resolvedCatalog']),
        'sourceProfile': json['sourceProfile'] == null ? undefined : ProfileDtoFromJSON(json['sourceProfile']),
        'resolutionMetadata': json['resolutionMetadata'] == null ? undefined : ResolutionMetadataFromJSON(json['resolutionMetadata']),
        'controlTransformations': json['controlTransformations'] == null ? undefined : ((json['controlTransformations'] as Array<any>).map(ControlTransformationFromJSON)),
        'sspId': json['sspId'] == null ? undefined : json['sspId'],
    };
}

export function ResolutionDataToJSON(json: any): ResolutionData {
    return ResolutionDataToJSONTyped(json, false);
}

export function ResolutionDataToJSONTyped(value?: ResolutionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resolvedCatalog': CatalogDtoToJSON(value['resolvedCatalog']),
        'sourceProfile': ProfileDtoToJSON(value['sourceProfile']),
        'resolutionMetadata': ResolutionMetadataToJSON(value['resolutionMetadata']),
        'controlTransformations': value['controlTransformations'] == null ? undefined : ((value['controlTransformations'] as Array<any>).map(ControlTransformationToJSON)),
        'sspId': value['sspId'],
    };
}

